import { t } from "../hooks/translations"
import { Check } from "../icons/check"
import css from "../style.module.scss"

export const Benefits = function Benefits({ incentive = false }: { incentive?: boolean }) {
  return (
    <div className={incentive ? css["incentive-benefits-container"] : css["benefits-container"]}>
      <p style={{ marginBottom: 16 }} className={css.paragraph}>
        {t("your_benefits")}
      </p>
      <ul className={css.benefits}>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_1")}</span>
        </li>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_2")}</span>
        </li>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_3")}</span>
        </li>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_4")}</span>
        </li>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_5")}</span>
        </li>
        <li className={css["benefits-item"]}>
          <span className={css["benefits-icon"]}>
            <Check size={16} color="black" />
          </span>
          <span>{t("benefits_6")}</span>
        </li>
      </ul>
    </div>
  )
}
